exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-date-picker .el-picker-panel__body .el-picker-panel__content {\r\n  width: 432px;\n}\n.mybtn {\r\n  display: none !important;\n}\n.hide {\r\n  display: inline-block !important;\n}\n#myinput {\r\n  width: 188px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  border-radius: 4px;\r\n  border: 1px solid #cdcde4;\r\n  padding: 0px 15px;\r\n  font-size: inherit;\n}\n#ljr .el-form-item__content {\r\n  width: 221px;\n}\n.small-text {\r\n  font-size: 13px;\r\n  color: #a7a2a2;\n}\n.el-dialog--center .el-dialog__body {\r\n    text-align: initial;\r\n    padding: 0px 10px 10px;\n}\r\n", ""]);

// exports
